import { Injectable } from '@angular/core';
import { SearchBoxComponentService, SearchBoxConfig } from '@spartacus/storefront';
import { switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomSearchBoxService extends SearchBoxComponentService {
  launchSearchPage2(query: string, config: SearchBoxConfig): void {
    this.getProductResults(config).pipe(
      take(1),
      switchMap((productResult) => {
        const productCodeMatch = productResult.products?.find((product) => product.code === query);

        if (productResult?.products && productCodeMatch) {
          return this.routingService.go({
            cxRoute: 'product',
            params: productCodeMatch ,
          });
        } else {
          return this.routingService.go({
            cxRoute: 'search',
            params: { query },
          });
        }
      })
    ).subscribe();
  }
}